import PropTypes from 'prop-types';

/**
 * Email input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 * @param {string} props.label - label text that appears above the input
 * @param {boolean} props.required - true if input is required, false otherwise
 * @param {string} props.charLimit - maximum number of characters that can be input
 * @param {string} props.value - the current value held in the input (used with useState)
 * @param {Function} props.setValue - function for setting some state to the current input value
 */
const EmailInput = ({ id, placeholder, label, required, charLimit, value, setValue }) => {
    return (
        <>
            {label && 
                <label className="input-label" htmlFor={id}>
                    {required ? `${label} *` : label}
                </label>
            }
            <input
                type="email" 
                id={id}
                name={id}
                placeholder={placeholder}
                maxLength={charLimit}
                required={required}
                value={value}
                onChange={setValue}
            />

        </>
    );
};

EmailInput.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    charLimit: PropTypes.number,
    value: PropTypes.string,
    setValue: PropTypes.func,
};

export default EmailInput;